import React, { useState } from "react";

function InfoIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
      <path d="M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56zm0 82a26 26 0 11-26 26 26 26 0 0126-26zm48 226h-88a16 16 0 010-32h28v-88h-16a16 16 0 010-32h32a16 16 0 0116 16v104h28a16 16 0 010 32z" />
    </svg>
  );
}

function Tooltip({ text }) {
  if (!text) {
    return null;
  }

  return (
    <div className="tooltip-toggle-radio">
      <button type="button" className="tooltip-toggle p-0 border-0 bg-transparent" aria-label={text}>
        <InfoIcon />
      </button>
      <div className="tooltip">
        <div className="tooltip-inner">{text}</div>
      </div>
    </div>
  );
}

function HelpOption({ option, selectedValue, onChange }) {
  return (
    <div className="col-md-6 column mb-3">
      <div className="btn-selector-box d-flex flex-column">
        <div className="d-flex flex-nowrap align-items-center position-relative">
          <input
            type="radio"
            name="helpSelector"
            id={option.id}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={(event) => onChange(event.target.value)}
            className="d-none"
            autoComplete="off"
          />
          <label htmlFor={option.id} className="radio-lable">
            <span className="radio-title">{option.title}</span>
          </label>
          <Tooltip text={option.hint} />
        </div>
        <span className="radio-subTitle">{option.subtitle}</span>
      </div>
    </div>
  );
}

export default function HelpSelectorIsland({ config }) {
  const [selectedOption, setSelectedOption] = useState("");

  const nextDisabled = selectedOption.length === 0;

  const handleNext = () => {
    const selectedItem = (config.options || []).find((option) => option.value === selectedOption);

    if (selectedItem?.nextUrl) {
      window.location.href = selectedItem.nextUrl;
    }
  };

  return (
    <section id="helpSelector">
      <section>
        <div className="row clearfix">
          <div className="col-md-8 offset-md-2 text-center my-4">
            <h1 className="text-bolder text-dark-blue">{config.title}</h1>
          </div>
        </div>
        <div className="row clearfix">
          {(config.options || []).map((option) => (
            <HelpOption
              key={option.value}
              option={option}
              selectedValue={selectedOption}
              onChange={setSelectedOption}
            />
          ))}
        </div>
        <button
          type="button"
          className={`btn btn-wide btn-arrow-right btn-next btn-lg${nextDisabled ? " disabled" : ""}`}
          disabled={nextDisabled}
          onClick={handleNext}
        >
          <span>{config.nextLabel}</span>
        </button>
      </section>
    </section>
  );
}
